// extracted by mini-css-extract-plugin
module.exports = {"footer-block":"bundle-unit-skeleton_footer-block__RElxs"};